import React from 'react';
import { motion } from 'framer-motion';
import { BusinessCard } from './BusinessCard';
import { businesses } from '../data/businesses';
import { useLanguage } from '../context/LanguageContext';
interface BusinessesProps {
  onNavigate?: (page: 'home' | 'about' | 'contact' | 'business', slug?: string) => void;
}
export function Businesses({
  onNavigate
}: BusinessesProps) {
  const {
    t
  } = useLanguage();
  return <section className="bg-[#f2f2f4] py-24 md:py-32 px-6" id="businesses" data-id="element-62">
      <div className="max-w-7xl mx-auto" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-64">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-65">
            {t.businesses.label}
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6" data-id="element-66">
            {t.businesses.title}
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-67" />
          <p className="text-[#86868b] text-[18px] md:text-[20px] max-w-3xl mx-auto font-light leading-relaxed" data-id="element-68">
            {t.businesses.description}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12" data-id="element-69">
          {businesses.map((business, index) => <BusinessCard key={business.slug} name={business.name} description={business.description} location={business.location} index={index} onClick={() => onNavigate?.('business', business.slug)} data-id="element-70" />)}
        </div>
      </div>
    </section>;
}